import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { selectActivePlanSubscription } from '../../queries/selectors/products';
import { selectLatestSubscription } from '../../queries/selectors/bootstrap';

import { selectCurrentPaymentMethod } from '../../queries/selectors/payment';
import { selectClient } from '../../global-selectors';
import { PaymentMethods } from '../../enums';

const withMembershipPurchased = (WrappedComponent) => (props) => {
  // TODO: ajustar el wrapper para que funcione con el nuevo flujo de affilates
  const Wrapper = ({
    currentMembership,
    paymentMethod,
    client,
    latestSubscription,
    ...props
  }) => {
    const { location } = props;

    // Incomm flows ignores subscription validation
    if (paymentMethod === 'incomm') {
      return <WrappedComponent {...props} />;
    }
    const hasLastSubscriptionAsAffiliates = latestSubscription?.purchaseState?.paymentMethod === PaymentMethods.AFFILIATES;
    // TODO: Affiliates flows ignores subscription validation
    if (hasLastSubscriptionAsAffiliates || paymentMethod === PaymentMethods.AFFILIATES) {
      return <WrappedComponent {...props} />;
    }

    if (!currentMembership || !currentMembership.productId) {
      return <Redirect to={`/${client}/subscribe/subscriptions${location.search}`} />;
    }

    return <WrappedComponent {...props} />;
  };

  Wrapper.propTypes = {
    currentMembership: PropTypes.object.isRequired,
    paymentMethod: PropTypes.string.isRequired,
    client: PropTypes.string.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string
    }).isRequired,
  };

  return Wrapper(props);
};

const mapStateToProps = (state) => ({
  currentMembership: selectActivePlanSubscription(state),
  paymentMethod: selectCurrentPaymentMethod(state),
  latestSubscription: selectLatestSubscription(state),
  client: selectClient(state)
});

const mapDispatchToProps = {};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withMembershipPurchased
);
